import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getRoutes, getMerchantBasic } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import certificationObj from '@/store/observable/certification'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/register', '/forgot', '/terms', '/privacyPolicy', '/certification/step','/materialDescription'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {

  if(getToken() && !whiteList.includes(to.path)) {
    // store.dispatch('user/getStatus')
    // store.dispatch('app/getMessage')
    // store.commit('user/SET_NAME', getName())
  }
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)
  document.title = getPageTitle('跨境支付业务系统')

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: getRoutes()[0].path })
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        try {
          if (!to.path.includes('certification')) {
            if (getMerchantBasic().outerStatus === 'finished' && getMerchantBasic().operatorStatus === 'om_approved') {
              if (getMerchantBasic().hasSetPassword) {
                next()
              } else if (to.path !== '/setting') {
                next({ path: '/setting', query: {id: Math.random()} })
              } else {
                next()
              }
            } else if ( getMerchantBasic().operatorStatus === 'initial' && getMerchantBasic().merchantIntegrateStep === 'initial') {
              next({ path: '/certification'})
            } else if (getMerchantBasic().operatorStatus === 'initial' && getMerchantBasic().merchantIntegrateStep !== 'initial') {
              next({ path: '/certification/step', query: {type: getMerchantBasic().type}})
            } else {
              next({ path: '/certification/audit', query: {type: getMerchantBasic().type} })
            }
          } else {
            if (getMerchantBasic().outerStatus === 'finished' && getMerchantBasic().operatorStatus === 'om_approved') {
              next({ path: getRoutes()[0].path })
            } else {
              next()
            }
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login`)
        }
      }
    }
    NProgress.done()
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
